import tbHeader from './tb-header.component';

export default angular
    .module('tb.header', [])
    .component('tbHeader', tbHeader)
    .name;
